import { Box } from "@mui/material";
import React from "react";
import Table from "../../../components/Table";
import { ANALYTICS_TABLE_COLUMNS } from "../data/AnalyticsHelpers";

const AnalyticsTable = ({
  data,
  loading,
  totalRecords,
  onItemClicked,
  onRowsPerPageChange,
  limit,
  currentPage,
}) => {
  return (
    <Box mt={4} mb={5}>
      <Table
        columns={ANALYTICS_TABLE_COLUMNS}
        data={data}
        progressPending={loading}
        paginationTotalRows={totalRecords}
        onItemClicked={onItemClicked}
        fixedHeaderScrollHeight="100%"
        responsive
        rowsPerPage={limit}
        currentPage={currentPage}
        onRowsPerPageChange={onRowsPerPageChange}
        showRecordsCountText={false}
      />
    </Box>
  );
};

export default AnalyticsTable;
